export const gitCommit = 'be14ac55-dirty'
